import { RoverStatsigUser, StatsigUser } from './types';

const customAttributesChanged = (
  currentCustom: StatsigUser['custom'] | undefined,
  newCustom: RoverStatsigUser['custom'] | undefined
): boolean => {
  const currentKeys = currentCustom ? Object.keys(currentCustom) : [];
  const newKeys = newCustom ? Object.keys(newCustom) : [];

  if (currentKeys.length !== newKeys.length) {
    return true;
  }

  if (!currentKeys.every((key) => newKeys.includes(key))) {
    return true;
  }

  for (const key of newKeys) {
    if (currentCustom?.[key] !== newCustom?.[key]) {
      return true;
    }
  }

  return false;
};

export const userNeedsUpdate = (
  currentUser: StatsigUser | undefined,
  newUser: RoverStatsigUser
): boolean => {
  if (!currentUser) {
    return true;
  }

  if ((currentUser.appVersion ?? null) !== (newUser.appVersion ?? null)) return true;
  if (currentUser.country !== newUser.country) return true;
  if (currentUser.email !== newUser.email) return true;
  if (currentUser.userID !== newUser.userID) return true;
  if (currentUser.customIDs?.rover_cid !== newUser.customIDs?.roverCID) return true;
  if (currentUser.customIDs?.environment_id !== newUser.customIDs?.environmentID) return true;
  if (customAttributesChanged(currentUser.custom, newUser.custom)) return true;

  return false;
};

export const createUserPayload = (
  newUser?: RoverStatsigUser,
  currentUser?: StatsigUser
): Partial<StatsigUser> => {
  const payload: Partial<StatsigUser> = {};
  payload.appVersion = newUser?.appVersion ?? currentUser?.appVersion;
  payload.country = newUser?.country ?? currentUser?.country;
  payload.email = newUser?.email;
  payload.userID = newUser?.userID;
  payload.custom = {
    ...currentUser?.custom,
    ...newUser?.custom,
  };
  payload.customIDs = {
    rover_cid: newUser?.customIDs?.roverCID ?? currentUser?.customIDs?.rover_cid,
    environment_id: newUser?.customIDs?.environmentID ?? currentUser?.customIDs?.environment_id,
  };

  return payload;
};
